import React, { useContext } from "react";
import {  useNavigate } from "react-router-dom";
import { useTranslation } from "@hooks/useTranslation";
import { useAuth } from "@context/AuthContext";
import { TokenContext } from "@context/TokenContext";

const CompraPendiente = () => {

  const navigate = useNavigate();
  const { getToken,getVerified } = useContext(TokenContext);
  const user =JSON.parse(localStorage.getItem('user_arteonu'))
  const {translate} = useTranslation();
  const { openAuth } = useAuth();


  return (
    <section className="CheckoutBox CompraExitosa">
      <article>
        <div className="StepCheckout">
          <div className="Selected"></div>
          <div className="Selected"></div>
          <div className="Selected"></div>
          <div className="Selected"></div>
        </div>
        <div className="icon-Check"></div>
        <h5>{translate('checkout.success_pending')}</h5>
        <b>{translate('checkout.your_pay_pending')}</b>
        <div className="FontSmall">
          {translate('checkout.send1_pending')} {user?.email ?? ''}
          <br /> {translate('checkout.send2_pending')}
          <br /><br />
          {translate('checkout.check_spam')}
        </div>
        

        {(!user || (user.verified == 0 && user.active == 0)) ? (<div className="FontSmall StepRegister" >
          <p>
            {translate('checkout.not_registered')}
          </p>
          <p className="sec">
            {translate('checkout.register_benefits')}
          </p>
          <a
            href="javascript:void(0)"
            onClick={() => openAuth('CrearCuenta')}
          >
            {translate('checkout.create_account')}
          </a>

          <div className="ButtonDarkMedium" onClick={() => navigate("/home")} style={{ marginTop: '20px', cursor: 'pointer' }}>
             {translate('checkout.init')}
          </div>


        </div>) : ''}

        {(user && user.verified == 0 && user.active == 1) ?
          <>
            <div className="ButtonDarkMedium" onClick={() => navigate("/home")} style={{ marginTop: '20px', cursor: 'pointer' }}>
               {translate('checkout.init')}
            </div>
          </> : ''}

        {(getToken() && getVerified()) ? (
          <div className="Row">
            <div
              className="ButtonLightMedium"
              onClick={() => navigate("/mis-pedidos")}
            >
              {translate('checkout.check')}
            </div>
            <div className="ButtonDarkMedium" onClick={() => navigate("/home")}>
              {translate('checkout.continue_shopping')}
              <i className="icon-Check"></i>
            </div>
          </div>) : ''}
        
      </article>
    </section>
  );
};

export default CompraPendiente;
